module.exports = __webpack_public_path__ + "static/img/profile__bg.2a0f93a6.svg";